import {useNodeId, useNodes} from "@xyflow/react";
import {useEdgeBuilder} from "../association-network-context.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export const LoadImage = ({nodeId}) => {
    const nodes = useNodes();
    const {images} = useEdgeBuilder()

    const nodeFind = nodes.find((n) => n.id === nodeId);
    if (nodeFind && nodeFind.attach_id) {
        return <img
            src={ API_KEEPER + "/ged/attach/" + nodeFind.attach_id}
            alt={`passage-image`}
            className="m-auto h-full w-full object-contain"
        />
    }

    const image = images.find(i => i.id === nodeId);
    if (!image) return <></>;

    if (image.file) {
        const url = URL.createObjectURL(image.file);

        return <img
            src={url}
            alt={`passage-image`}
            className="m-auto h-full w-full object-contain"
        />
    }
}